export default __webpack_public_path__ + "static/media/allergy-icon.6b0d7ffc.svg";